<div>
    <input type="file" class="hidden-file-input" accept="image/png, image/jpeg" onclick="this.value = null"
      (change)="onFileSelected($event)" #fileUpload required>
    <h1>Add Author</h1>
    <br>
    <form [formGroup]="bookForm">
      <label class="fixed-size" for="first-name">Title: </label>
      <input id="title" type="text" formControlName="title">
      <br>
      <label class="fixed-size" for="author">Author: </label>
      <input id="author" type="text" formControlName="author" class="typeahead"
            [ngbTypeahead]="searchAuthors" />
      <br>
      <label class="fixed-size" for="purchase-link">Purchase Link: </label>
      <input id="purchase-link" type="text" formControlName="purchaseLink">
      <br>
      <div *ngIf="selectedFile != undefined; else noFile">
        <label class="fixed-size" for="title-image">Book Image: </label>
        <label>{{fileName}}</label><button class="remove-button" (click)="removeFile()">x</button>
      </div>
      <ng-template #noFile>
        <label class="fixed-size" for="title-image">Book Image: </label>
        <button class="add-button" (click)="fileUpload.click()">Add Image</button>
      </ng-template>
      <br>
      <label for="summary">Summary: </label><br>
      <textarea class="text-area-90" style="background-color:rgb(255, 255, 255);color:rgb(0, 0, 0);" rows="10" cols="40"
        formControlName="summary"></textarea>
      <br>
    </form>
    <form [formGroup]="bookForm" (ngSubmit)="onSubmit()"></form>
    <button class="cancel-button" type="cancel" (click)="this.cancelClicked()">Cancel</button>
    <button class="primary-button" type="submit" [disabled]="!bookForm.valid" (click)="this.onSubmit()">Submit</button>
  </div>